module.exports = __webpack_public_path__ + "static/media/Lateral_End Stage_Z2.bbc6e87c.png";